import {createSlice, PayloadAction, Slice} from "@reduxjs/toolkit";
import {PAGE, PAGE_SIZE} from "../../../utils/constants.ts";

export interface ChangePage {
    page: number,
    pageName: string,
}

export interface ChangePageSize {
    pageSize: number,
    pageName: string,
}

export interface PaginationState {
    changed: boolean,
    page: number,
    pageSize: number,
    pageName: string,
}

const initialState: PaginationState = {
    changed: false,
    page: PAGE,
    pageSize: PAGE_SIZE,
    pageName: '',
}

const paginationSlice: Slice<PaginationState> = createSlice({
    name: "pagination",
    initialState,
    reducers: {
        init: (state, action: PayloadAction<PaginationState>) => {
            state.page = action.payload.page
            state.pageSize = action.payload.pageSize
            state.pageName = action.payload.pageName
            state.changed = true
        },
        setPage: (state, action: PayloadAction<ChangePage>) => {
            if (action.payload.pageName === state.pageName) {
                state.page = action.payload.page
            } else {
                state.page = 0
            }
            state.pageName = action.payload.pageName
            state.changed = true
        },
        setPageSize: (state, action: PayloadAction<ChangePageSize>) => {
            if (action.payload.pageSize >= 0) {
                state.page = Math.floor(state.pageSize * state.page / action.payload.pageSize)
                state.pageSize = action.payload.pageSize
            }
            state.pageName = action.payload.pageName
            state.changed = true
        }
    }
})

export const { init, setPage, setPageSize } = paginationSlice.actions;

export default paginationSlice;
